(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snz-product-main"]) return;
  try {
    
  (function () {
    function centerActive(root) {
      var strip = root.querySelector('[data-snz-mthumbs]');
      if (!strip) return;
      var act = strip.querySelector('[aria-current="true"]');
      if (!act) return;
      var left = act.offsetLeft - (strip.clientWidth - act.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-snz-arrow]');
      if (!btn) return;
      var root = btn.closest('[data-snz-pdp]');
      if (!root) return;
      var mobile = !!btn.closest('.snz-gm');
      var items = Array.prototype.slice.call(root.querySelectorAll(mobile ? '[data-snz-dot]' : '[data-snz-thumb]'));
      if (!items.length) return;
      var cur = items.findIndex(function (el) { return el.getAttribute('aria-current') === 'true'; });
      var next = ((cur < 0 ? 0 : cur) + Number(btn.getAttribute('data-snz-arrow')) + items.length) % items.length;
      items[next].click();
    });
    var t;
    document.addEventListener('scroll', function (e) {
      var tr = e.target && e.target.closest && e.target.closest('[data-snz-track]');
      if (!tr) return;
      clearTimeout(t);
      t = setTimeout(function () { var r = tr.closest('[data-snz-pdp]'); if (r) centerActive(r); }, 120);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
